if (!customElements.get('europelab-site-header')) {
  customElements.define('europelab-site-header', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const panels = [...this.querySelectorAll('details')];
      const search = this.querySelector('.site-header__search');
      const input = search.querySelector('input');
      const status = this.querySelector('.site-header__status');
      const results = this.querySelector('.site-header__results');
      const update = () => this.toggleAttribute('data-solid', !this.hasAttribute('data-over-hero') || window.scrollY > 24);
      update();
      window.addEventListener('scroll', update, { ...options, passive: true });
      panels.forEach(panel => panel.addEventListener('toggle', () => {
        if (!panel.open) return;
        panels.forEach(other => { if (other !== panel) other.open = false; });
        if (panel === search) input.focus();
      }, options));
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) panels.forEach(panel => { panel.open = false; });
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = panels.find(panel => panel.open);
        if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
      }, options);
      this.querySelectorAll('nav').forEach(nav => nav.addEventListener('click', event => {
        if (event.target.closest('a')) panels.forEach(panel => { panel.open = false; });
      }, options));
      const lookup = async () => {
        this.request?.abort();
        this.request = new AbortController();
        const query = input.value.trim();
        results.replaceChildren();
        if (!query) { status.textContent = 'Wpisz nazwę produktu.'; return; }
        status.textContent = 'Szukam…';
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '6' });
        try {
          const response = await fetch(`${this.dataset.searchUrl}.json?${params}`, { signal: this.request.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (input.value.trim() !== query || !this.isConnected) return;
          const products = data.resources?.results?.products || [];
          status.textContent = products.length ? `Znalezione produkty: ${products.length}` : 'Brak produktów dla tej nazwy.';
          const money = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: this.dataset.currency });
          products.forEach(product => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = product.url;
            const thumbnail = product.featured_image?.url || product.image;
            if (thumbnail && typeof thumbnail === 'string') {
              const image = document.createElement('img');
              image.src = thumbnail;
              image.alt = '';
              image.width = 44; image.height = 56;
              link.append(image);
            }
            const text = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = product.title;
            text.append(title);
            if (product.price !== undefined && Number.isFinite(Number(product.price))) {
              const price = document.createElement('small');
              price.textContent = money.format(Number(product.price));
              text.append(price);
            }
            link.append(text); item.append(link); results.append(item);
          });
        } catch (error) {
          if (error.name !== 'AbortError') status.textContent = 'Nie udało się wyszukać. Spróbuj ponownie.';
        }
      };
      input.addEventListener('input', () => { clearTimeout(this.timer); this.request?.abort(); this.timer = setTimeout(lookup, 220); }, options);
      search.querySelector('form').addEventListener('submit', () => { clearTimeout(this.timer); this.request?.abort(); }, options);
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); clearTimeout(this.timer); }
  });
}
